import { createSlice } from "@reduxjs/toolkit";
import { fetchDoctorConsultationPricingReducer } from "../../reducer/doctor-consultation-pricing/fetchDoctorConsultationPricingReducer";
import { updateConsultationFeeReducer } from "../../reducer/doctor-consultation-pricing/updateConsultationFeeReducer";

import i18n from "../../i18n";
const initialState = {
  data: {
    online: null,
    onsite: null,
  },
  isLoading: false,
  error: null,
};

const doctorConsultationPricingSlice = createSlice({
  name: "doctorConsultationPricing",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDoctorConsultationPricingReducer.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(
        fetchDoctorConsultationPricingReducer.fulfilled,
        (state, action) => {
          state.isLoading = false;
          state.data = action.payload || { online: null, onsite: null };
          console.log("Consultation Fees Loaded:", action.payload);
        },
      )
      .addCase(
        fetchDoctorConsultationPricingReducer.rejected,
        (state, action) => {
          state.isLoading = false;
          state.error = action.payload || i18n.t("toast.failedToLoadConsultationFees");
        },
      )
      .addCase(updateConsultationFeeReducer.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateConsultationFeeReducer.fulfilled, (state, action) => {
        state.isLoading = false;
        // The updated fee will be fetched again by the component
        console.log("Consultation fee updated:", action.payload);
      })
      .addCase(updateConsultationFeeReducer.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || i18n.t("toast.failedToUpdateConsultationFee");
      });
  },
});

export default doctorConsultationPricingSlice.reducer;
